module.exports = __webpack_public_path__ + "img/quartel.1c64f1ba.jpg";